import { get, values } from 'lodash'
import { getConfigurationByDeviceId } from 'store/Configurations/selector'

export const getDevicesById = (state) => get(state, ['devices', 'byId'])

export const getDevice = (state, uuid) => get(getDevicesById(state), [uuid], {})

export const getDevices = (state) => values(getDevicesById(state))

export const getDeviceWithConfiguration = (state, uuid) => {
  const device = getDevice(state, uuid)
  const configuration = getConfigurationByDeviceId(state, device.deviceId) || {}

  return {
    ...device,
    configuration,
  }
}

export const getDevicesWithConfigurations = (state) =>
  getDevices(state).map((device) => ({
    ...device,
    configuration: getConfigurationByDeviceId(state, device.deviceId) || {},
  }))
